import { render, staticRenderFns } from "./LastCollectDataTable.vue?vue&type=template&id=fce62d78&"
import script from "./LastCollectDataTable.vue?vue&type=script&lang=js&"
export * from "./LastCollectDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template_rpjj46s3fsyrbdrx36iiyr4l4y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\21.zhangzhiyi\\web-system\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fce62d78')) {
      api.createRecord('fce62d78', component.options)
    } else {
      api.reload('fce62d78', component.options)
    }
    module.hot.accept("./LastCollectDataTable.vue?vue&type=template&id=fce62d78&", function () {
      api.rerender('fce62d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/LastCollectDataTable.vue"
export default component.exports